const QuestionMarkIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <g id="Group_8368" data-name="Group 8368" transform="translate(0 -1.5)">
                <g id="Group_8366" data-name="Group 8366" transform="translate(0 1.5)">
                    <path
                        id="Path_3579"
                        data-name="Path 3579"
                        d="M3.058,16.717A9.66,9.66,0,1,0,.375,10.035,9.632,9.632,0,0,0,3.058,16.717Z"
                        transform="translate(-0.035 -0.035)"
                        fill="none"
                        stroke="#0c3b8d"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                    <path
                        id="Path_3580"
                        data-name="Path 3580"
                        d="M10.475,13.272v-1.33a.6.6,0,0,1,.6-.6,2.409,2.409,0,0,0,2.41-2.409V8.763A2.576,2.576,0,0,0,10.91,6.188h-.059A2.634,2.634,0,0,0,8.217,8.822v.439M10.475,15.2v.219"
                        transform="translate(-0.768 -0.578)"
                        fill="none"
                        stroke="#1650b4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.467"
                    />
                </g>
            </g>
        </svg>
    );
};

export default QuestionMarkIcon;
